import React, { useEffect, useState } from 'react';
import {
  ATMField,
  ATMHeader,
  ATMSegment,
  ATMIcon,
  ATMInput,
  ATMSelect,
} from 'shared-it-appmod-ui';
import { FlightCategory } from 'src/constants';
import { useFlightCategoryContext } from 'src/contexts/flight-category.context';
import { actionTypes } from 'src/ducks/flight-category.duck';
import Lang from 'src/libraries/language';
// import { IRequestFormMethods } from 'src/models/request.model';
import { getFlightCategoryStatus } from 'src/selectors/flight-category.selector';
import FlightRequestConstructionContractorForm from '../../flight-request-construction-contractor/flight-request-construction-contractor-form/flight-request-construction-contractor-form.component';
import FlightRequestPatrolPassengerForm from '../../flight-request-patrol-passenger/flight-request-patrol-passenger-form/flight-request-patrol-passenger-form.component';
// import FlightRequestPatrolContractorForm from '../../flight-request-patrol-passenger-contractor/flight-request-patrol-passenger-contractor-form/flight-request-patrol-passenger-contractor-form.component';
import FlightRequestDroneSDGE from '../../flight-request-drone/flight-request-drone-sdge/flight-request-drone-sdge.component';
import FlightRequestDroneContractor from '../../flight-request-drone/flight-request-drone-contractor/flight-request-drone-contractor.component';
import FlightRequestConstructionForm from '../../flight-request-construction/flight-request-construction-form/flight-request-construction-form.component';
import FlightPatrolPassengerContractorForm from '../../flight-request-patrol-passenger-contractor/flight-request-patrol-passenger-contractor-form/flight-request-patrol-passenger-contractor-form.component';

// type IProps = IRequestFormMethods & {
//   isEdit?: boolean;
// };

const FlightRequestInformationForm: React.FC<any> = ({
  control,
  errors,
  isEdit,
  ...props
}) => {
  const { state, actions } = useFlightCategoryContext();
  const [category, setCategory] = useState<FlightCategory | undefined>(
    control.defaultValuesRef?.current?.passengerFlight?.isOldSCG
      ? 6
      : control.defaultValuesRef?.current?.request?.flightFlag
  );

  useEffect(() => {
    actions.listGET();
  }, [actions.listGET]);

  const status = getFlightCategoryStatus(
    state,
    actionTypes.FLIGHT_CATEGORY_FETCH
  );

  let content: React.ReactNode = (
    <ATMSegment placeholder textAlign="center">
      <p>
        <ATMIcon name="exclamation" circular />
        Choose the flight category to enter further details
      </p>
    </ATMSegment>
  );

  switch (category) {
    case FlightCategory.PatrolPassenger: {
      if (control?.defaultValuesRef?.current?.passengerFlight?.isOldFlight) {
        content = (
          <FlightPatrolPassengerContractorForm
            control={control}
            errors={errors}
            isEdit={isEdit}
          />
        );
      } else {
        content = (
          <FlightRequestPatrolPassengerForm
            control={control}
            errors={errors}
            isEdit={isEdit}
            {...props}
          />
        );
      }
      break;
    }
    case FlightCategory.ContractorConstruction: {
      content = (
        <FlightRequestConstructionContractorForm
          control={control}
          errors={errors}
          {...props}
        />
      );
      break;
    }
    case FlightCategory.ConstructionWork: {
      content = (
        <FlightRequestConstructionForm
          control={control}
          errors={errors}
          {...props}
        />
      );
      break;
    }
    // case FlightCategory.ContractorPatrol: {
    //   content = (
    //     <FlightRequestPatrolPassengerForm
    //       control={control}
    //       errors={errors}
    //       isEdit={isEdit}
    //       {...props}
    //     />
    //   );
    //   break;
    // }
    case FlightCategory.DroneFlightInternal: {
      content = (
        <FlightRequestDroneSDGE control={control} errors={errors} {...props} />
      );
      break;
    }
    case FlightCategory.DroneFlightExternal: {
      content = (
        <FlightRequestDroneContractor
          control={control}
          errors={errors}
          {...props}
        />
      );
      break;
    }
  }

  return (
    <ATMSegment>
      <ATMHeader>{Lang.TTL_REQUEST_FLIGHT_INFORMATION}</ATMHeader>

      {!isEdit && !control.defaultValuesRef?.current?.request?.flightFlag ? (
        <div>
          <ATMHeader as="h3" content={Lang.LBL_CHOOSE_CATEGORY} />
          <ATMField
            name="request.flightFlag"
            width={6}
            control={control}
            as={ATMSelect}
            options={state.list.map((value) => ({
              key: value.flightFlag,
              value: value.flightFlag,
              text: value.flightCategory,
            }))}
            placeholder={Lang.LBL_SELECT}
            selectOnBlur={false}
            error={errors.request?.flightFlag}
            loading={status.fetching}
            disabled={status.fetching}
            onChange={([_, { value }]) => {
              setCategory(value);
              return value;
            }}
          />
        </div>
      ) : (
        <ATMField
          name="request.flightFlag"
          control={control}
          as={ATMInput}
          type="hidden"
          className="hidden"
        />
      )}

      {content}
    </ATMSegment>
  );
};

export default FlightRequestInformationForm;
